import React, { useEffect } from 'react'
import styles from './ChangePlan.styles'
import Popup from '../../../components/popup/Popup'
import Heading from '../../../components/heading/Heading'
import { HEADING } from '../../../components/heading/constants/constants'
import { componentKey as authenticationComponentKey } from '../../authentication/AuthenticationSlice'
import { componentKey } from './ChangePlanSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import Label from '../../../components/label/Label'
import Button from '../../../components/button/Button'
import { BUTTON_TYPE } from '../../../components/button/constants'
import Icons from '../../../components/icons/Icons'
import { VEC_ICON_NAME } from '../../../components/icons/constants'
import { LABEL_WEIGHT } from '../../../components/label/constants'
import HorizontalSeparator from '../../../components/separator/horizontalSeparator/HorizontalSeparator'
import Checkbox from '../../../components/checkbox/basecheckbox/Checkbox'
import { USER_PLAN_NAME, USER_TYPE_MAPPING } from '../../../../libs/customhooks/constants'
import { useUserTypeInfo } from '../../../../libs/customhooks/useUserTypeInfo'
import PaymentDrawer from '../paymentdrawer/PaymentDrawer'
import { PLACE_OF_ORIGIN_FOR_PAYMENT } from '../paymentdrawer/constants'
import PaymentDataService from '../../../../services/PaymentDataService'
import { logoutUser } from '../../authentication/AuthenticationSaga'
import Loadable from '../../../components/loadable/Loadable'
import { getPlanDetails, getUserPlanExpiryDate } from './ChangePlanSaga'
import { COMMON_LOADING_STATES, PLAN_LOADING_STATES, PLAN_LOADING_STATES_MESSAGE_MAP } from '../../constants/constants'
import useTxNavigate from '../../../../libs/txnavigate/TxNavigateHook'
import { getUserProfileAndPermissions } from '../../dashboard/DashboardSaga'
import EFileSubscriptionReminderPopup from './EFileSubscriptionReminderPopup'
import { addNotifications } from '../../toaster/ToasterPortalSlice'
import { TOASTER_VARIANT } from '../../../components/toast/constants'

export default function ChangePlan({
	showPopup = false,
	closePopup = () => {},
	disabledPlans = []
}) {
	const { signedInUser } = useSelector((state) => state[authenticationComponentKey])
	const { loadingState, purchasePlanDetails, userPlanReminderData } = useSelector((state) => state[componentKey])
	const [noticeManagement, setNoticeManagement] = useState(false)
	const [autoRenewEnterprise, setAutoRenewEnterprise] = useState(false)
	const [selectedPlanFee, setSelectedPlanFee] = useState(null);
	const [subscriptionReminderPlan, setSubscriptionReminderPlan] = useState({})
	
	const dispatch = useDispatch();
	const navigate = useTxNavigate();

	const { userType } = useUserTypeInfo();

	useEffect(() => {
        dispatch(getUserPlanExpiryDate())
    }, [])

	useEffect(() => {
			dispatch(getPlanDetails())
	}, [])

	const handleChangeNoticeManagement = (e) => {
		setNoticeManagement(e.target.checked)
	}

	const handleChangeAutoRenew = (e) => {
		setAutoRenewEnterprise(e.target.checked)
	}

	const isPlanSelected = (type) => {
		return signedInUser?.PlanName === type
	}

	const handleContinueExisting = () => {
		closePopup();
	}
	const navigateToComparePlans = () => {
		window.open('https://www.tax1099.com/tax-1099-efile-pricing', 'mywindow', 'noopener')
	}

	const navigateToTalkToExpert = () => {
		window.open('https://www.tax1099.com/schedule-a-demo', 'mywindow', 'noopener')
	}

	const getAmount = (PlanName) => {
		const price = purchasePlanDetails?.find( plan => plan.Type === PlanName)?.Price ?? 'undefined';
		switch(PlanName) {
			case USER_PLAN_NAME.ESSENTIAL_USER:
				return `$${price} Free`
			default:
				return `$${price} /Year`
		}
	}

	const selectPlan = (plan) => {
		if(signedInUser?.PlanName === USER_PLAN_NAME.EFILE_PLUS_USER){
			return setSubscriptionReminderPlan(plan);
		} 

		setSelectedPlanFee({
			id: USER_TYPE_MAPPING[plan.Type],
			planFee: parseInt(plan.Price) + ( plan.Type === USER_PLAN_NAME.ENTERPRISE_USER && noticeManagement ? plan.NoticeManagement : 0 ),
			IsFullYear: plan.Type === USER_PLAN_NAME.ENTERPRISE_USER ? true : null,
		})
	}

	const getLabel = (plan) => {
		switch(plan.Type) {
			case USER_PLAN_NAME.ESSENTIAL_USER :
				return 'For individuals and SMEs';
			case USER_PLAN_NAME.EFILE_PLUS_USER :
				return 'For medium business';
			case USER_PLAN_NAME.ENTERPRISE_USER :
				return 'For Enterprise';
		}
	}

	const getNoticeManagementAmount = () => {
		return purchasePlanDetails?.find( plan => plan.Type === USER_PLAN_NAME.ENTERPRISE_USER)?.NoticeManagement
	}

	const getPlanIcon = (planType) =>{
		switch(planType){
			case USER_PLAN_NAME.ESSENTIAL_USER :
				return VEC_ICON_NAME.ESSENTIAL_VECTOR
			case USER_PLAN_NAME.EFILE_PLUS_USER :
				return VEC_ICON_NAME.EFILE_PLUS_VECTOR
			case USER_PLAN_NAME.ENTERPRISE_USER :
				return VEC_ICON_NAME.ENTERPRISE_VECTOR
		}
	}

	const getPlanBadge = (planType) =>{
		switch(planType){
			case USER_PLAN_NAME.ESSENTIAL_USER :
				return VEC_ICON_NAME.ESSENTIAL_RIBBON
			case USER_PLAN_NAME.EFILE_PLUS_USER :
				return VEC_ICON_NAME.EFILE_PLUS_RIBBON
			case USER_PLAN_NAME.ENTERPRISE_USER :
				return VEC_ICON_NAME.ENTERPRISE_RIBBON
		}
	}

	const isPlanSelectable = (planType) => {
		switch(signedInUser?.PlanName) {
			case USER_PLAN_NAME.ENTERPRISE_USER:
				return true;
			case USER_PLAN_NAME.EFILE_PLUS_USER:
				if(planType === USER_PLAN_NAME.ENTERPRISE_USER) {
					return false;
				}
				return true;
			case USER_PLAN_NAME.ESSENTIAL_USER:
				return false;
		}
	}

	return (
		<Popup title={""} onCloseCb={closePopup} isPopupOpen={showPopup} customPopupHeaderStyles={styles.customPopupHeaderStyles} customPopupSyles={styles.userInfoPopupCustom} overlayStyles={styles.userInfoPopupOverlay} childrenStyles={styles.userInfoPopupChildren}>
			<div style={styles.mainContainer}>
				<Heading type={HEADING.H1} customStyle={styles.header}>{signedInUser.FirstName ?? ""} {signedInUser.MiddleName ?? ""} {signedInUser.LastName ?? ""}! Pick the plan that fits your needs best.</Heading>
				<div style={styles.headerInfo}>
					<Label customStyles={styles.recommendationText}>We recommend {userType} plan for you based on the information you provided earlier</Label>
					<Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} onClickCb={ navigateToComparePlans }>Compare Plans</Button>
				</div>

				<Loadable currentState={loadingState.state} loadingStates={PLAN_LOADING_STATES.PLANS_LOADING} messageMap={PLAN_LOADING_STATES_MESSAGE_MAP} isNewLoadable={true}>
					<div style={styles.plansMainContainer}>

						{ purchasePlanDetails?.length ? purchasePlanDetails?.filter( plan => !disabledPlans.includes(plan.Type) )?.map((plan, idx) => (
							<div key={"plan-card" + idx} style={{...styles.planBox, ...(isPlanSelected(plan.Type) ? styles.greenBorder : {})}}>
								<div style={{...styles.planInnerContainer, ...(isPlanSelected(plan.Type) ? styles.selectedBackground : {})}}>
									<Icons familyName={'vec'} iconName={getPlanIcon(plan.Type)}/>
									<Heading type={HEADING.H2} customStyle={{...styles.h2FontSize, ...(isPlanSelected(plan.Type) ? styles.selectedText : {})}}>{getLabel(plan)}</Heading>
									<div style={styles.pricingContainer}>
										<Label weight={LABEL_WEIGHT[700]} customStyles={{...styles.h2FontSize, ...(isPlanSelected(plan.Type) ? styles.selectedText : {})}}>{getAmount(plan.Type)}</Label>
										<Label customStyles={{...styles.labelFontSize, ...(isPlanSelected(plan.Type) ? styles.selectedText : {})}}>{plan.SubLabel}</Label>
									</div>
									<HorizontalSeparator/>
									<div style={styles.topRightRibbon}>
										<Icons familyName={'vec'} iconName={getPlanBadge(plan.Type)}/>
									</div>
								</div>
								<div style={styles.planDetails}>
									<div>
										<ul style={styles.featuresContainer}>
											{plan.Description.map(description => <li>{description}</li>)}
											{ plan.Type === USER_PLAN_NAME.ENTERPRISE_USER && (
												<>
													<li><div style={styles.checkBox}><Checkbox checked={noticeManagement} onChangeCb={(e) =>handleChangeNoticeManagement(e)}/> ${getNoticeManagementAmount()} Notice Management / YEAR</div></li>
													<li><div style={styles.checkBox}><Checkbox checked={autoRenewEnterprise} onChangeCb={(e) => handleChangeAutoRenew(e)}/> Auto-renewal enterprise account</div></li>
												</>
											
											)}
										</ul>
									</div>
									{!isPlanSelected(plan.Type) ? 
										<div style={styles.planActionRow}>
											<Button disabled={isPlanSelectable(plan.Type)} type={BUTTON_TYPE.PRIMARY} onClickCb={() => selectPlan(plan)}>Select Plan</Button>
											{ isPlanSelectable(plan.Type) ? <Label customStyles={styles.paddingTop}></Label> : <Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} onClickCb={navigateToTalkToExpert}>Talk to an Expert</Button> }
										</div>
										:
										<div style={styles.planActionRow}>
											<Button disabled={true} onClickCb={handleContinueExisting}>Current Plan</Button>
											<Label customStyles={styles.paddingTop}></Label>
										</div>
									}
								</div>
							</div>
						)) : null}
					</div>
				</Loadable>
			</div>
			{
				selectedPlanFee && <PaymentDrawer 
					isOpen={selectedPlanFee}
					isSubscription={true}
					onCloseCb={() => {
						setSelectedPlanFee(null)
					}}
					fees={{
						OnlySeparateStatefiling: "false",
						TotalFilingFee: selectedPlanFee?.planFee,
						FilingFee: selectedPlanFee?.planFee,
						USPSFee: "0",
						TINMatchFee: "0",
						StateFee: "0",
						TINCount: "0",
						StateFilingCount: "0",
						USPSCount: "0",
						FormCount: "0"
					}}
					filingFeeLabel={`Plan Fee ${(selectedPlanFee?.id === 3 && noticeManagement)? "+ Notice Management" : ""}`}
					paymentServiceFunctionCb={PaymentDataService.purchasePlan}
					calculatePrepaySalesTax={true}
					paymentServiceFunctionExtraParams={{
						IsautorenewChecked: (selectedPlanFee?.id === 3 && autoRenewEnterprise) ?? false,
						planPlanType: selectedPlanFee?.id === 2 ? 1 : selectedPlanFee?.id,
						IsNoticeChecked: noticeManagement,
						IsFullYear: selectedPlanFee?.IsFullYear,
					}}
					calculateEstimatedTax={true}
					placeOfOriginforpayment={PLACE_OF_ORIGIN_FOR_PAYMENT.CHANGE_PLAN}
					onPaymentSuccessCb={() => {
						dispatch(getUserProfileAndPermissions())
						dispatch(addNotifications({ heading: "Success", message: "Upgrade plan successful", variant: TOASTER_VARIANT.SUCCESS }));
						closePopup();
					}}
				/>
			}
			

			{subscriptionReminderPlan.Type ?
				<EFileSubscriptionReminderPopup
					isOpen={subscriptionReminderPlan.Type}
					onCloseCb={() => setSubscriptionReminderPlan({})}
					currentPlanUpgradeClickCb={() => {
						setSelectedPlanFee({
							id: USER_TYPE_MAPPING[subscriptionReminderPlan.Type],
							planFee: parseInt(userPlanReminderData.enhancePlan) + (subscriptionReminderPlan.Type === USER_PLAN_NAME.ENTERPRISE_USER && noticeManagement ? subscriptionReminderPlan.NoticeManagement : 0),
							IsFullYear: false,
						})
					}}
					subscribeForYearClickCb={() => {
						setSelectedPlanFee({
							id: USER_TYPE_MAPPING[subscriptionReminderPlan.Type],
							planFee: parseInt(userPlanReminderData.updatePlanToEnterprise) + (subscriptionReminderPlan.Type === USER_PLAN_NAME.ENTERPRISE_USER && noticeManagement ? subscriptionReminderPlan.NoticeManagement : 0),
							IsFullYear: true,
						})
					}}
					htmlContent={userPlanReminderData.html}
				/>
				: null}
		</Popup>
	)
}